import { query } from '../utils/http'
import useCursorQuery from './useCursorQuery'

export type DocumentMetadata = {
  id: string
  title: string
  author: string
  lang: string
  group: 'users' | 'orgs' | 'public'
  groupId: string
  toLangs?: string[],
  difficulty: 0 | 1 | 2,
  numChapters: number,
}

const useDocs = ({
  fromLang,
  toLang,
  group,
  groupId,
  difficulty,
}: {
  fromLang?: string
  toLang?: string
  group?: 'public' | 'users' | 'orgs'
  groupId?: string,
  difficulty?: '0' | '1' | '2',
} = {}) => {
  const {
    data: docs,
    isRefetching: isDocsLoading,
    isLoading: isNextDocsLoading,
    isNext,
    isPrev,
    next,
    prev,
  } = useCursorQuery<DocumentMetadata[]>(
    ['docs', fromLang, toLang, group, groupId, difficulty],
    (cursor?: string) =>
      query(`docs`, {
        params: {
          fromLang,
          toLang,
          limit: 10,
          ...(
              difficulty !== undefined
              && difficulty !== null
              && (difficulty as string) !== ''
              && { difficulty }
          ),
          ...(group && { group }),
          ...(groupId && { groupId }),
          ...(cursor && { cursor }),
        },
        headers: cursor && { 'X-Cursor': cursor },
      }).then((response) =>
        Promise.all([
          response.json() as Promise<DocumentMetadata[]>,
          Promise.resolve(
            (response.headers as Headers)?.get(
              'X-Cursor',
            ) ?? undefined,
          ),
        ]),
      ),
  )

  return {
    docs,
    isLoading: isDocsLoading,
    isNextLoading: isNextDocsLoading,
    isNext,
    isPrev,
    next,
    prev,
  }
}

export default useDocs
